/* eslint-disable */
import React, { Component } from "react";
import { loginapi } from "./auth";

import Logo from "./assets/RilukLogoF.png";
import axios from "axios";
import Loading from "./assets/loading.gif";
import { cl } from "./components/functions";


/* jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
  }
}; */


const isChrome = true;

class SignIn extends Component {
  state = {
    email: "",
    password: "",
    error: "",
    isServerDown: false
  };
  handleSignIn = async e => {
    e.preventDefault();
    const btnLogin = document.getElementById("buttonLogin");
    const btnLoading = document.getElementById("buttonLoading");

    //    btnLogin = 'login100-form-btn2';
    //    var button = $('button[type=submit]', this);
    // disable and set the text
    btnLogin.hidden = true;
    btnLoading.hidden = false;
    //btnLogin.textContent= "ok"


    const { email, password } = this.state;
    if (!email || !password) {
      this.setState({ 
      error: "Preencha e-mail e senha para continuar!",
      isServerDown: false
      });
      btnLogin.hidden = false;
      btnLoading.hidden = true;
    } else {
      try {
        var bodyFormData = new FormData();
        //localStorage.setItem('linkbase', 'http://adminrl.dyndns.org:8085');
        //sessionStorage.setItem('linkbase', 'https://riluk.ragepro.com.br:8086');
        //sessionStorage.setItem('linkbase', 'https://apirlk.riluk.com.br');
        sessionStorage.setItem('linkbase', 'https://newapi.riluk.com.br');
        sessionStorage.setItem('linkbase2', 'https://api.riluk.com.br');
        const klinkbase = sessionStorage.getItem('linkbase');
        const klinkbaseapi = sessionStorage.getItem('linkbase2');
        global.gLinkBase = klinkbase;
        global.gLinkBaseApi = klinkbaseapi;
        //cl("clglobal.gLinkBaseApi",global.gLinkBaseApi);
        //return
        //console.log("linkbase",klinkbase);
        bodyFormData.set('apikey', '9998BG9GSN3B8UNYaVNHHESVENB89YHE8NA');
        bodyFormData.set('email', email);
        //bodyFormData.set('pass', password);
        bodyFormData.set('doc', password);
        //bodyFormData.append('password', 'senha');
        const response = await axios({
          method: 'post',
          url: global.gLinkBase+'/login.php?apikey=9998BG9GSN3B8UNYaVNHHESVENB89YHE8NA',
          //url: global.gLinkBase+'/appyou/login.php?apikey=9998BG9GSN3B8UNYaVNHHESVENB89YHE8NA',
          //url: 'https://api.espacomarciobagagine.com.br/login.php',
          //url: 'http://192.168.15.200:8085/appyou/login.php?apikey=9998BG9GSN3B8UNYaVNHHESVENB89YHE8NA',
          // url: 'http://192.168.99.250:3333/loginusers',
          data: bodyFormData,
          config: { headers: { 'Content-Type': 'multipart/form-data' } }
        });

        //const response = await api.post("/loginusers2", { email, password });
        //console.log(response.data);
        //console.log("login-: ", response.data);
        if (response.data) {
          this.setState({
            error: "",
            isServerDown: false
          });
          loginapi(response.data);
          
          //irHome();
          window.open("/", "_self");

        } else {
          this.setState({
            error: "E-mail e CPF/CNPJ devem estar exatamente iguais ao cadastro da administradora.",
            isServerDown: false
          });
          btnLogin.hidden = false;
          btnLoading.hidden = true;
        }
      } catch (err) {
        console.log(err);

        btnLogin.hidden = false;
        btnLoading.hidden = true;

        const isNetworkError =
          err.code === "ERR_NETWORK" ||
          err.code === "ECONNABORTED" ||
          (typeof err.message === "string" &&
            (
              err.message.includes("Network Error") ||
              err.message.includes("Failed to fetch") ||
              err.message.includes("ERR_NAME_NOT_RESOLVED")
            ));

        if (isNetworkError || !err.response) {
          this.setState({
            error: "Não foi possível conectar no momento. Pode ser instabilidade na internet ou na operadora. Se o problema persistir, utilize a opção abaixo.",
            isServerDown: true
          });
        } else {
          this.setState({
            error: "E-mail e CPF/CNPJ devem estar exatamente iguais ao cadastro da administradora.",
            isServerDown: false
          });
        }
      }
    }
  };

  content() {
const styles = {
  alertloginBox: {
    marginTop: "18px",
    padding: "14px 16px",
    borderRadius: "16px",
    fontSize: "13.5px",
    lineHeight: "1.5",
    textAlign: "center",
    fontWeight: "500",
    letterSpacing: "0.2px",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
    opacity: 0,
    transform: "translateY(-8px)",
    animation: "none"
  },

  // 🔴 erro servidor (MAIS LEVE)
  alertloginError: {
    background: "rgba(255, 120, 120, 0.10)",
    border: "1px solid rgba(255, 120, 120, 0.25)",
    color: "#ffecec"
  },

  // 🟡 erro dados (MENOS AMARELO)
  alertloginWarning: {
    background: "rgba(255, 215, 120, 0.12)",
    border: "1px solid rgba(255, 215, 120, 0.25)",
    color: "#fff6db"
  }
};
    if (isChrome) {
      return (
        <div>

          <div className="limiter">
            <div className="container-login100" style={{ backgroundImage: 'url("images/bg-01.jpg")' }}>
              <div className="wrap-login100">
                <form className="login100-form validate-form" onSubmit={this.handleSignIn}>
                  <span className="login100-form-logo">
                    <img className="imglogo" src={Logo} alt="Login" />
                    {/*<i className="zmdi zmdi-landscape" />*/}
                  </span>
                  <span className="login100-form-title p-b-76 p-t-27">
                    {/* JVF - APP */}
                  </span>
                  <div className="wrap-input100 validate-input" data-validate="Enter username">
                    <input className="input100" type="input" name="login" autoComplete="username email" placeholder="Email" onChange={e => this.setState({ email: e.target.value })} />
                    <span className="focus-input100" data-placeholder="" />
                  </div>
                  <div className="validate-input wrap-input100bgg " data-validate="Enter password">
                    <input className="input100" type="text" name="pass" placeholder="CPF ou CNPJ" onChange={e => this.setState({ password: e.target.value })} />
                    <span className="focus-input100" data-placeholder="" />
                  </div>
                  <div className="txt1 text-center p-t-10">
                  CPF/CNPJ (só números)
                  </div>
<div className="text-center p-t-12">
  {this.state.error && (
    <div
style={{
  ...styles.alertloginBox,
  ...(this.state.isServerDown
    ? styles.alertloginError
    : styles.alertloginWarning),

  opacity: this.state.error ? 1 : 0,
  transform: this.state.error ? "translateY(0)" : "translateY(-20px)",
  transition: "opacity 0.45s ease, transform 0.45s cubic-bezier(0.22, 1, 0.36, 1)",
  pointerEvents: this.state.error ? "auto" : "none"
}}
    >
      <div style={{ fontSize: "16px", marginBottom: "4px" }}>
        {this.state.isServerDown ? "⚠️" : "ℹ️"}
      </div>
      <div>{this.state.error}</div>
    </div>
  )}
</div>                  
                  {/*}  <div className="contact100-form-checkbox">
                                <input className="input-checkbox100" id="ckb1" type="checkbox" name="remember-me" />
                                <label className="label-checkbox100" htmlFor="ckb1">
                                    Remember me
                            </label>
      </div>*/}
                  <div className="container-login100-form-btn">
                    <button type="submit" className="login100-form-btn" id="buttonLogin" name="buttonLogin">

                      <i className="fa fa-cube" aria-hidden="true"></i>
                      &nbsp;<span id="spanLogin">Entrar</span>
                    </button>
                    <button type="" className="login100-form-btn" id="buttonLoading" name="buttonLoading" hidden>

                      <span id="spanLogin"><img id="imgloading" width="50px" alt="Loading.." src={Loading}></img>Aguarde</span>

                    </button>
                  </div>

                  <div className="text-center p-t-20">
{this.state.isServerDown && (
  <div style={{ marginTop: "12px" }}>
    <a
      href="https://app.riluk.com.br/diagnostico/"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#ffffffcc",
        fontSize: "13px",
        textDecoration: "underline",
        fontWeight: "500"
      }}
    >
      Problema para acessar?
    </a>
  </div>
)}
                  </div>
                  {/* <div className="text-center p-t-30">
                    <a className="txt1" href="/">
                      Esqueceu a senha ?
    </a>
                  </div> */}
                </form>
              </div>
            </div>
          </div>
          <div id="dropDownSelect1" />

        </div>
      )
    } else {
      return (

        <div>
          <div className="limiter">
            <div className="container-login100" style={{ backgroundImage: 'url("images/bg-01.jpg")' }}>
              <div className="wrap-login100">
                <form className="login100-form validate-form" onSubmit={this.handleSignIn}>
                  <span className="login100-form-logo">
                    <img className="imglogo" src={Logo} alt="Login" />
                    {/*<i className="zmdi zmdi-landscape" />*/}
                  </span>
                  <span className="login100-form-title p-b-75 p-t-27">
                    {/* JVF - APP */}
                  </span>
                  <div className="wrap-input100 validate-input" data-validate="Enter username">
                    <img src="https://www.google.com/chrome/static/images/chrome-logo.svg" className="login100-form-logo" alt="logo" />
                    <div className="text-center p-t-10">
                      <span className="login100-form-title p-t-14 p-t-17">
                        Utilize o Navegador Chrome do seu Computdor
                      </span>
                    </div>
                    <div className="text-center p-t-30">
                      <a
                        className="App-link"
                        href="https://www.google.com/intl/pt-BR/chrome/"
                        //target="_blank"
                        rel="noopener noreferrer"
                      >
                        Click aqui para Instalar !
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div >
      )
    }
  }
  //
  render() {
    return (
      <div>
        {this.content()}
      </div>
    );
  }
}

export default SignIn;